import {Box, Container} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import React, { useEffect, useState } from 'react'
import Content from './Content.js';
import Image from './Image'

function Home() 
{
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    function animate(e)
    {
        const { clientX, clientY } = e;
        setMousePosition({ x: clientX, y: clientY });
    }
  return (
    
    <Box onMouseMove={animate} my={2} >
        <Grid 
            container 
            rowSpacing={5}
        >
            <Grid item xs={12} sm={12} md={6} 
                order={{xs:"2",sm:"2",md:"1"}} 
                    sx={{
                        display:"grid",
                        alignItems:"center",
                        flexDirection:"column",
                    }}
                  
            >
                <Content/>
            </Grid>
            
            <Grid item xs={12} sm={12} md={6} 
                order={{ xs:"1",sm:"1",md:"2"}} 
                sx={{
                    display:"flex",
                    justifyContent:"center",
                    alignItems:"center",
                }}
                
            >
                <Image position={mousePosition}/>
            </Grid>
        </Grid>
    </Box>
    
  )
}

export default Home